import React from "react";

export default function Datenschutz() {
  return (
    <div>
      <section className="py-24 md:py-32 bg-[#F8FAFC]" data-testid="datenschutz-header">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <span className="text-sm font-semibold tracking-wide uppercase text-[#FF3B30]" style={{ fontFamily: 'Plus Jakarta Sans' }}>
            Rechtliches
          </span>
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#0F172A] mt-3 max-w-3xl"
            style={{ fontFamily: 'Plus Jakarta Sans' }}
            data-testid="datenschutz-page-title"
          >
            Datenschutzerklärung
          </h1>
        </div>
      </section>

      <section className="py-24 md:py-32" data-testid="datenschutz-content">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <p className="text-slate-600 leading-relaxed mb-12">
            Diese Datenschutzerklärung erläutert, wie personenbezogene Daten beim Besuch der Website von ServicePoint Huwiler verarbeitet werden.
          </p>

          <div className="space-y-12">
            {/* Datenerfassung */}
            <div>
              <h2 className="text-2xl font-semibold text-[#0F172A] mb-4" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                Datenerfassung
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Beim Besuch dieser Website können vom Hosting-Anbieter automatisch bestimmte Informationen erfasst werden. Diese können umfassen:
              </p>
              <ul className="space-y-2 text-slate-600">
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF3B30] mt-2 shrink-0" />
                  IP-Adresse
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF3B30] mt-2 shrink-0" />
                  Browsertyp
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF3B30] mt-2 shrink-0" />
                  Betriebssystem
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF3B30] mt-2 shrink-0" />
                  Datum und Uhrzeit des Zugriffs
                </li>
              </ul>
              <p className="text-slate-600 leading-relaxed mt-4">
                Diese Daten werden ausschliesslich zur Sicherstellung des ordnungsgemässen Betriebs und der Sicherheit der Website verwendet.
              </p>
            </div>

            {/* Kontaktanfragen */}
            <div className="border-t border-slate-100 pt-12">
              <h2 className="text-2xl font-semibold text-[#0F172A] mb-4" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                Kontaktanfragen
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Wenn Sie uns per E-Mail oder über das Kontaktformular kontaktieren, werden die von Ihnen angegebenen Informationen ausschliesslich zur Beantwortung Ihrer Anfrage verwendet. Ihre Daten werden nicht an Dritte weitergegeben.
              </p>
            </div>

            {/* Datenschutz */}
            <div className="border-t border-slate-100 pt-12">
              <h2 className="text-2xl font-semibold text-[#0F172A] mb-4" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                Datenschutz
              </h2>
              <p className="text-slate-600 leading-relaxed">
                ServicePoint Huwiler trifft angemessene technische und organisatorische Massnahmen zum Schutz personenbezogener Daten gegen unbefugten Zugriff, Verlust oder Missbrauch.
              </p>
            </div>

            {/* Ihre Rechte */}
            <div className="border-t border-slate-100 pt-12">
              <h2 className="text-2xl font-semibold text-[#0F172A] mb-4" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                Ihre Rechte
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Sie haben das Recht, Auskunft über gespeicherte personenbezogene Daten zu verlangen und gegebenenfalls deren Berichtigung oder Löschung zu beantragen.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Bei Fragen zum Datenschutz kontaktieren Sie uns bitte unter:
              </p>
              <a
                href="mailto:servicepoint.huwiler89@gmail.com"
                className="inline-block text-[#FF3B30] hover:underline mt-2 font-medium"
                data-testid="datenschutz-email-link"
              >
                servicepoint.huwiler89@gmail.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
